import PushNotifications from "@commons/push-notifications";
import React from "react";

const AdminPushNotification = () => {
  return <PushNotifications />;
};

export default AdminPushNotification;
